import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_index/_authed")({
  component: RouteComponent,
  head: () => ({
    meta: [{ name: "robots", content: "noindex,nofollow" }],
  }),
  beforeLoad({ context }) {
    if (!context.authed) {
      throw redirect({ to: "/auth", statusCode: 302 });
    }
    return {
      user: context.user!,
      authed: true,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
